import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const PlayerSparkCard = ({ player, gameLogs, isPitcher, onClick }) => {
  const name = player?.person?.fullName || '--';
  const lastName = name.split(' ').slice(1).join(' ') || name;
  const pos = player?.position?.abbreviation || '--';
  const num = player?.jerseyNumber || '--';

  const { sparkOption, recentAvg } = useMemo(() => {
    const group = isPitcher ? 'pitching' : 'hitting';
    const splits = gameLogs?.stats?.find(s => s.group?.displayName === group)?.splits?.slice(0, 10).reverse() || [];
    if (!splits.length) return { sparkOption: null, recentAvg: '--' };

    const vals = isPitcher
      ? splits.map(s => s.stat?.strikeOuts || 0)
      : splits.map(s => s.stat?.hits || 0);

    const totalAB = splits.reduce((a, s) => a + (s.stat?.atBats || 0), 0);
    const totalH = splits.reduce((a, s) => a + (s.stat?.hits || 0), 0);
    const avg = totalAB > 0 ? (totalH / totalAB).toFixed(3).replace('0.', '.') : '--';

    const option = {
      backgroundColor: 'transparent',
      grid: { top: 2, right: 2, bottom: 2, left: 2 },
      xAxis: { type: 'category', show: false },
      yAxis: { type: 'value', show: false },
      series: [{
        type: 'line',
        data: vals,
        smooth: true,
        lineStyle: { color: isPitcher ? '#c4333e' : '#a9c9b1', width: 1.5 },
        symbol: 'none',
        areaStyle: { color: isPitcher ? 'rgba(196,51,62,0.15)' : 'rgba(169,201,177,0.15)' },
      }],
    };
    return { sparkOption: option, recentAvg: avg };
  }, [gameLogs, isPitcher]);

  return (
    <div onClick={onClick}
      className="border border-[rgba(101,141,113,0.4)] bg-[rgba(0,0,0,0.08)] p-2.5 flex flex-col gap-2 cursor-pointer hover:border-[#a9c9b1] hover:bg-[rgba(255,255,255,0.04)] transition-all group">
      <div className="flex items-start justify-between">
        <div>
          <div className="flex items-center gap-1.5">
            <span className="text-[8px] font-bold text-[#658d71]">#{num}</span>
            <span className={`text-[8px] font-black uppercase px-1 ${isPitcher ? 'bg-[rgba(196,51,62,0.3)] text-[#c4333e]' : 'bg-[rgba(101,141,113,0.3)] text-[#a9c9b1]'}`}>{pos}</span>
          </div>
          <p className="text-[11px] font-black uppercase tracking-wide text-white group-hover:text-[#d8ceb3] transition-colors leading-tight mt-0.5">{lastName}</p>
        </div>
        {!isPitcher && (
          <div className="flex flex-col items-end">
            <span className="text-[8px] text-[#658d71] font-bold uppercase">AVG</span>
            <span className="text-sm font-black text-[#d8ceb3] tabular-nums">{recentAvg}</span>
          </div>
        )}
      </div>
      {sparkOption && (
        <ReactECharts option={sparkOption} style={{ height: '32px' }} opts={{ renderer: 'svg' }} />
      )}
      <p className="text-[8px] text-[#658d71] uppercase tracking-widest">
        {isPitcher ? 'K trend (last 10 G)' : 'Hit trend (last 10 G)'}
      </p>
    </div>
  );
};

export default PlayerSparkCard;